import styled from "styled-components";

import PhoneCarousel from "./PhoneCarousel";

import { MYSTOCK_CAPTURES } from "src/assets/images/captures";

function StockPreview() {
  return (
    <S.Container>
      <S.ScreenContainer>
        <PhoneCarousel captures={MYSTOCK_CAPTURES} />

        <span>마이주식 서비스 미리보기</span>
      </S.ScreenContainer>
      <S.TextContainer>
        <S.SubText>로그인 없이 종목 이야기 세 건을 먼저 읽습니다</S.SubText>

        <S.MainText>
          쓰던 계정으로 간편 로그인하면
          <br />
          바로 이어서 봅니다
        </S.MainText>
      </S.TextContainer>
    </S.Container>
  );
}

export default StockPreview;

const S = {
  Container: styled.section`
    background: rgba(78, 91, 242, 0.06);
    width: 100%;
    height: 1039px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  `,
  ScreenContainer: styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 341px;
    span {
      text-align: center;
      font-size: 20px;
      letter-spacing: -0.46px;
      margin-top: 20px;
    }
  `,
  TextContainer: styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 135px;
  `,
  SubText: styled.p`
    font-size: 40px;
    letter-spacing: -0.92px;
    white-space: nowrap;
  `,
  MainText: styled.h2`
    font-size: 60px;
    font-weight: 700;
    line-height: 80px;
    letter-spacing: -1.38px;
    margin-top: 22px;
    white-space: nowrap;
  `,
};
